export default __webpack_public_path__ + "cc1c0c2.png";